import { useAxios } from "@hooks";
import { useQuery } from "@tanstack/react-query";
import { AssessorSummary } from "../../types/grading/PendingCorrection";

/**
 * Users in the Assessor role for the current tenant (for the assignment picker).
 */
export const useGetAssignableAssessors = (options?: { enabled?: boolean }) => {
  const axios = useAxios();

  return useQuery<AssessorSummary[]>({
    queryKey: ["assignableAssessors"],
    queryFn: async () => {
      const response = await axios.get<AssessorSummary[]>(
        `/api/grading/assignable-assessors`
      );
      return response.data;
    },
    enabled: options?.enabled !== false,
  });
};

export default useGetAssignableAssessors;
